import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.scss';
import logo from '../../../assets/images/vrp-logo.png';
import { navItems as NAV, primaryCta, providerPortal } from '../../../content/site.js';

const LockIcon = () => (
  <svg className="vh-header__portal-icon" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 10V7a5 5 0 0 1 10 0v3M6 10h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1Z"
    />
  </svg>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <header className={`vh-header ${scrolled ? 'is-scrolled' : ''} ${open ? 'is-open' : ''}`}>
      <div className="vh-header__bar u-container">
        <Link to="/" className="vh-header__brand" onClick={() => setOpen(false)} aria-label="Virginia Rehab Physicians home">
          <img className="vh-header__logo" src={logo} alt="Virginia Rehab Physicians" width="342" height="172" />
        </Link>

        <nav className="vh-header__nav" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink key={item.href} to={item.href} className="vh-header__link">
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="vh-header__actions">
          <a
            href={providerPortal.href}
            className="vh-header__portal"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LockIcon />
            {providerPortal.label}
          </a>
          <Link to={primaryCta.href} className="btn btn--gold vh-header__cta">
            {primaryCta.label}
            <span className="btn__arrow" aria-hidden="true">→</span>
          </Link>
          <button
            type="button"
            className="vh-header__burger"
            aria-expanded={open}
            aria-controls="vh-mobile"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      <div id="vh-mobile" className="vh-mobile" hidden={!open}>
        <nav className="vh-mobile__nav" aria-label="Mobile">
          {NAV.map((item) => (
            <NavLink key={item.href} to={item.href} className="vh-mobile__link" onClick={() => setOpen(false)}>
              {item.label}
            </NavLink>
          ))}
          <Link to={primaryCta.href} className="btn btn--gold vh-mobile__cta" onClick={() => setOpen(false)}>
            {primaryCta.label} →
          </Link>
          <a
            href={providerPortal.href}
            className="vh-mobile__portal"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
          >
            <LockIcon />
            {providerPortal.label}
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
